import { useEffect, useState } from 'react';
import ModalBuyorSellTransaction from './ModalBuyorSellTransaction';
import Modal from '../Components/Modal';
import ModalSelectAccount from './ModalSelectAccount';
import { toast } from 'react-toastify';
import SelecctModal from './SelecctModal';
import { Data } from '../PaymentMethods/Data';

export const BuyandSellOfferTableModals = ({
  openModal,
  handleOpenandCloseModal,
  offerDetails,
  cxId,
}) => {
  const inputObject = {
    amount: '',
    rate: '',
    message: '',
  };

  const [bidData, setBidData] = useState(inputObject);
  const [trackModalState, setTrackModalState] = useState('');
  const [selectModalContent, setSelectModalContent] = useState();
  const [modalArrayContent, setModalArrayContent] = useState();
  const { localData, foreignData } = Data();
  const allBankAccount = [...localData, ...foreignData];

  //handle success message and error message
  const handleToast = (state, message) => {
    if (state === 'success') {
      toast.success(` ${message}`, {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else if (state === 'error') {
      toast.error(`${message}`, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };

  useEffect(() => {
    if (openModal === 'accept' || openModal === 'bid') {
      setTrackModalState(openModal);
    } else {
      return;
    }
  }, [openModal]);
  //for dashboard table

  const allCurrency = allBankAccount?.map((currency) => ({
    id: currency?.id,
    currencyId: currency?.currency?.id,
    name: `${currency?.bank_name} - ${currency?.country?.name}`,
    flag: currency?.country?.flag,
    code: currency?.currency?.name,
  }));

  //setting moadlcontent
  useEffect(() => {
    if (
      localData.length &&
      foreignData.length &&
      allCurrency.length === allBankAccount.length
    ) {
      setModalArrayContent(allCurrency);
    }
  }, [
    localData.length,
    foreignData.length,
    allCurrency.length,
    allBankAccount.length,
  ]);

  return (
    <div className='w-full'>
      <Modal open={openModal === 'offerdetails'}>
        <ModalBuyorSellTransaction
          content={{
            offerDetails,
            handleOpenandCloseModal,
            setBidData,
            bidData,
          }}
        />
      </Modal>
      <Modal open={openModal === 'bid' || openModal === 'accept'}>
        <ModalSelectAccount
          content={{
            handleOpenandCloseModal,
            cxId,
            bidData,
            handleToast,
            setBidData,
            selectModalContent,
            trackModalState,
            closeModal: 'close',
          }}
        />
      </Modal>
      <Modal open={openModal === 'selectpopup'}>
        <SelecctModal
          setClickedItem={setSelectModalContent}
          handleOpenandCloseModal={handleOpenandCloseModal}
          modalArrayContent={modalArrayContent}
          trackModalState={trackModalState}
          offerDetails={offerDetails}
          title='Bank Accounts'
        />
      </Modal>
    </div>
  );
};
